import React, { useEffect, useMemo } from "react";
import PuffLoader from "react-spinners/PuffLoader";
import "./YoutubeData.css";
import { useLoadTypeContentData } from "../../../../Utils/customHooks/UpToDateContent/useLoadTypeContent";
import { getContentFeedDateWindowFromComponent } from "../../../../Screens/DashboardView/StayUpToDate/AddComponentPicker/contentFeedTimeframe";
import { BsHourglassSplit, BsLink45Deg } from "react-icons/bs";
import Card from "react-bootstrap/esm/Card";
import { StayFeedLoadingPlaceholder } from "../../../../Screens/DashboardView/MasterTemplateEditor/WebsiteLibFeedSkeleton";
import { useParams } from "react-router-dom";
import {
  handleFirstImage,
  handleNavigate,
  updateIsEmptyStatus,
} from "../../../../Utils/StayUpToDate/RenderComponent";
import track, {
  TRACKING_TYPES,
} from "../../../../Utils/SupabaseServices/Track";
import { useDomLoaded } from "../../../../hooks/DomLoadedContext";
import FrontendTemplate from "../StructureTemplates/FrontendTemplate";
import PostTemplate from "../CommonComponents/PostTemplate";
import { FeedSectionEmptyState } from "../FeedSectionEmptyState";
import { websiteEditorFeedEmptyMessage } from "../../../../Screens/DashboardView/MasterTemplateEditor/websiteEditorFeedEmptyMessage";

const YoutubeData = (props: any) => {
  let platform = "youtube";
  let type = "VIDEO";
  const itemsPerPage = 3;
  const {
    user_id,
    username,
    handleRedirect,
    brand_color,
    isHandleNavigate,
    component,
    removedPostIds,
    isLinks,
    title,
    from,
    designTokens,
    templateGridLoaderProps,
    showEmptyInEditor = false,
  } = props;
  const contentDateWindow = useMemo(
    () => getContentFeedDateWindowFromComponent(component),
    [component?.details, component?.id]
  );

  const { isLoading: YoutubeDataLoading, data: YoutubeData }: any =
    useLoadTypeContentData(
      username,
      user_id,
      platform,
      type,
      removedPostIds,
      component?.content_order,
      component?.custom_order?.split(","),
      component?.shoppable_content_filter,
      component?.pinned_posts?.split(",") || [],
      component?.shoppable_status_filter || "all",
    "default",
    "default",
    true,
    contentDateWindow
  );

  const youtubeItems = useMemo(() => {
    if (!YoutubeData?.pages?.length) {
      return [];
    }
    return YoutubeData.pages.reduce((acc: any[], page: any) => {
      if (Array.isArray(page?.data)) {
        acc.push(...page.data);
      }
      return acc;
    }, []);
  }, [YoutubeData]);
  const totalCount = YoutubeData?.pages?.[0]?.total_count ?? 0;
  const param = useParams();
  const domLoaded = useDomLoaded();
  useEffect(() => {
    const checkEmptyStatus = async () => {
      if (!YoutubeDataLoading) {
        if (!YoutubeData || totalCount === 0) {
          if (!showEmptyInEditor) {
            await updateIsEmptyStatus(title, user_id, component.id,from);
          }
          // setIsLoading(false);
        } else {
          await handleFirstImage(
            title,
            component?.id,
            youtubeItems?.[0],
            user_id,
            from
          );
          // setIsLoading(false);
        }
      }
    };
    checkEmptyStatus();
  }, [YoutubeDataLoading, YoutubeData, youtubeItems, totalCount]);

  return (
    <div>
      {YoutubeDataLoading || !domLoaded ? (<StayFeedLoadingPlaceholder
          designTokens={designTokens}
          from={from}
          component={component}
          templateGridLoaderProps={templateGridLoaderProps}
        />) : (
        <>
          {youtubeItems && youtubeItems.length > 0 ? (
            <PostTemplate
              processedData={youtubeItems}
              total_count={totalCount}
              component={component}
              user_id={user_id}
              username={username}
              handleRedirect={handleRedirect}
              brand_color={brand_color}
              title={title}
              from={from}
              type={type}
              itemsPerPage={itemsPerPage}
              platform={platform}
              pinnedPostIds={component?.pinned_posts?.split(",") || []}
              isLinks={isLinks}
              designTokens={designTokens}
            />
          ) : showEmptyInEditor ? (
            <FeedSectionEmptyState
              title={title}
              designTokens={designTokens}
              message={websiteEditorFeedEmptyMessage("platform", { platform: "YouTube" })}
            />
          ) : (
            ""
          )}
        </>
      )}
    </div>
  );
};

export default YoutubeData;
